import { render, staticRenderFns } from "./orderOpen.vue?vue&type=template&id=5c56e8bb&"
import script from "./orderOpen.vue?vue&type=script&lang=js&"
export * from "./orderOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c56e8bb')) {
      api.createRecord('5c56e8bb', component.options)
    } else {
      api.reload('5c56e8bb', component.options)
    }
    module.hot.accept("./orderOpen.vue?vue&type=template&id=5c56e8bb&", function () {
      api.rerender('5c56e8bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/components/orderOpen.vue"
export default component.exports